import { Box, Container, Grid2, IconButton, Stack } from "@mui/material";
import React from "react";
import { AnimatedButton } from "../../ui/AnimatedButton";
import {
  ArrowBack,
  EmailOutlined,
  GitHub,
  LinkedIn,
} from "@mui/icons-material";
import StyledTypography from "../../ui/StyledTypography";
import { grey } from "@mui/material/colors";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const NotFound: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.3,
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const childVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100,
      },
    },
  };

  return (
    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <motion.div variants={childVariants}>
          <Link to="/">
            <AnimatedButton
              backgroundColor="rgb(15, 15, 15)"
              sx={{
                position: "absolute",
                top: 50,
                left: 50,
                height: 40,
                width: 165,
              }}
            >
              <ArrowBack sx={{ fontSize: 18, mr: 1 }} />
              Back To Home
            </AnimatedButton>
          </Link>
        </motion.div>
        <Stack
          spacing={10}
          sx={{
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <motion.div variants={childVariants}>
              <StyledTypography
                colors={[grey[500], grey[900]]}
                sx={{
                  fontSize: {
                    xs: 150,
                    sm: 200,
                    md: 350,
                  },
                  fontWeight: 600,
                  position: "relative",
                  zIndex: 0,
                }}
              >
                404
              </StyledTypography>

              <StyledTypography
                colors={[grey[200], grey[700]]}
                sx={{
                  fontSize: {
                    xs: 30,
                    sm: 40,
                    md: 65,
                  },
                  fontWeight: "Regular",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                  textAlign: "center",
                  zIndex: 1,
                }}
              >
                Page Not Found
              </StyledTypography>
            </motion.div>
          </Box>

          <motion.div variants={childVariants}>
            <Grid2 container spacing={5} justifyContent="center">
              {[
                {
                  Icon: EmailOutlined,
                  href: "mailto:supremache@gmail.com",
                  label: "Email",
                },
                {
                  Icon: GitHub,
                  href: "https://github.com/Supremache",
                  label: "GitHub",
                },
                {
                  Icon: LinkedIn,
                  href: "https://www.linkedin.com/in/abdulrahman-othman-5a4a1331a/",
                  label: "LinkedIn",
                },
              ].map(({ Icon, href, label }) => (
                <Grid2 key={label}>
                  <IconButton
                    aria-label={label}
                    component="a"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon />
                  </IconButton>
                </Grid2>
              ))}
            </Grid2>
          </motion.div>
        </Stack>
      </motion.div>
    </Container>
  );
};

export default NotFound;
